
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import WaterPreventiveWorkCard from '../WaterPreventiveWorkCard/WaterPreventiveWorkCard';


export default function TTPPreventiveworkCard(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { RoleID } = userDetails.user
    const dispatch = useDispatch()

    const PreventiveWorkNavigate = (name, screenFlag) => {
        if (name === "Water Pressure") {
            navigate(`/waterpressurepreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Water Quality") {
            navigate(`/waterquantitypreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Security") {
            navigate(`/watersecuritypreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "House Keeping") {
            navigate(`/waterhousekeepingpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }

    const navigate = useNavigate()
    // console.log('DashProjectTypeId',DashProjectTypeId)
    return (
        <div>
            <div className="row ps-lg-3 pe-lg-3">
                <div className="col-12 col-md-6 col-lg-3 mb-2 ">
                    <WaterPreventiveWorkCard
                        title="Water Pressure"
                        imgPath='./assets/img/waterpressure.png'
                        count={Countdata.WaterPressureTotalCount ? Countdata.WaterPressureTotalCount : '0'}
                        // navLink='/waterpressurepreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>


                <div className="col-12 col-md-6 col-lg-3 mb-2 ">
                    <WaterPreventiveWorkCard
                        title="Water Quality"
                        imgPath='./assets/img/waterquantity.png'
                        count={Countdata.WaterQuantityTotalCount ? Countdata.WaterQuantityTotalCount : "0"}
                        // navLink='/waterquantitypreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>


                <div className="col-12 col-md-6 col-lg-3 mb-2 ">
                    <WaterPreventiveWorkCard
                        title="Security"
                        imgPath='./assets/img/insurance.png'
                        count={Countdata.SecurityTotalCount ? Countdata.SecurityTotalCount : '0'}
                        // navLink='/watersecuritypreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-2 ">
                    <WaterPreventiveWorkCard
                        title="House Keeping"
                        imgPath='./assets/img/house-cleaning.png'
                        count={Countdata.HouseKeepingTotalCount ? Countdata.HouseKeepingTotalCount : '0'}
                        // navLink='/waterhousekeepingpreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

               



            </div>

        </div>

    )

}
